import React from "react";

export const RailsContext = React.createContext({ i18nLocale: "en_ie" });
